// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import App from "./App";
import EventPage from "./Pages/EventPage";
import UserAgreement from "./Pages/UserAgreement";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/event/:id" element={<EventPage />} />
        <Route path="/" element={<App />} />
        <Route path="/Privacy" element={<UserAgreement />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
